import config from '../package.json';
import _ from 'lodash';

export const getClosedImportantNoticeLocalState = (state) =>
  _.get(
    state,
    `${config.name}/importantNotice.closedImportantNoticeLocalState`,
    [],
  );
